import {warningIcon} from '@deanone/dean-components';
import {getErrorMessageFromTranslationByErrorCode} from "@/mixins/errorMessage";

export function createNotification(v: object|any): object|any {
  return createNotificationFromData(v.data);
}

export function createNotificationFromData(data: object|any): object|any {
  let code: string|null = null;
  let message: string|null = null;

  if (true === data.comment?.$invalid) {
    code = 'ERR_INVALID_COMMENT';
  }

  else if (true === data.iban?.$invalid) {
    code = 'ERR_INVALID_IBAN';
  }

  else if (true === data.phoneNumber?.$invalid) {
    code = 'ERR_INVALID_PHONE_NUMBER';
  }

  else if (
    true === data.phoneNumberRangeFrom?.$invalid
    && false === data.phoneNumberRangeFrom?.internationalE164PhoneNumber
  ) {
    code = 'ERR_INVALID_PHONE_NUMBER_RANGE_FROM_FORMAT';
  }

  else if (
    true === data.phoneNumberRangeTo?.$invalid
    && false === data.phoneNumberRangeTo?.internationalE164PhoneNumber
  ) {
    code = 'ERR_INVALID_PHONE_NUMBER_RANGE_TO_FORMAT';
  }

  else if (
    true === data.phoneNumberRangeFrom?.$invalid
    && true === data.phoneNumberRangeTo?.$invalid
    && false === data.phoneNumberRangeFrom?.phoneNumberRange
    && false === data.phoneNumberRangeTo?.phoneNumberRange
  ) {
    code = 'ERR_INVALID_PHONE_NUMBER_RANGE';
  }

  else if (
    true === data.password?.$invalid
    && false === data.password?.minLength
  ) {
    code = 'ERR_PASSWORD_TOO_SHORT';
  }

  else if (
    true === data.password?.$invalid
    && (false === data.password?.hasUppercase || false === data.password?.hasLowercase || false === data.password?.hasNumber)
  ) {
    code = 'ERR_PASSWORD_TOO_WEAK';
  }

  if (code) {
    message = getErrorMessageFromTranslationByErrorCode(code);
  }

  if (null === message) {
    message = 'Niet alle velden zijn correct ingevuld.';
  }

  return validationMessage(message);
}

export function validationMessage(message: string): object|any {
  return {
    icon: warningIcon,
    title: 'Validatiefout',
    text: message,
    theme: 'warning',
  };
}
